import axAPI from "../../../../api/axios-instance";

export type RefreshPlayerPhotoResponse = {
  status: "ok";
  sourceUrl: string;
  s3Url: string;
  bytes: number;
};

type RefreshPlayerPhotoParams = {
  leagueId: number | string;
  playerId: number | string;
};

export const refreshPlayerPhoto = async ({
  leagueId,
  playerId,
}: RefreshPlayerPhotoParams): Promise<RefreshPlayerPhotoResponse> => {
  const { data } = await axAPI.post<RefreshPlayerPhotoResponse>(
    "/cms/player/photo/refresh",
    null,
    {
      params: {
        leagueId,
        playerId,
      },
    }
  );

  return data;
};
